import _regenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/regenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import router from "./router";
import store from "./store";
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login', '/auth-redirect']; // no redirect whitelist

router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(to, from, next) {
    var hasToken, hasRoles, roles, accessRoutes, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          // start progress bar
          NProgress.start();

          // set page title
          document.title = getPageTitle(to.meta.title);

          // determine whether the user has logged in
          hasToken = getToken();
          if (!hasToken) {
            _context.n = 8;
            break;
          }
          if (!(to.path === '/login')) {
            _context.n = 1;
            break;
          }
          // if is logged in, redirect to the home page
          next({
            path: '/'
          });
          NProgress.done();
          _context.n = 7;
          break;
        case 1:
          // determine whether the user has obtained his permission roles through getInfo
          hasRoles = store.getters.roles && store.getters.roles.length > 0;
          if (!hasRoles) {
            _context.n = 2;
            break;
          }
          next();
          _context.n = 7;
          break;
        case 2:
          _context.p = 2;
          _context.n = 3;
          return store.dispatch('user/getInfo');
        case 3:
          roles = _context.v;
          _context.n = 4;
          return store.dispatch('permission/generateRoutes', roles);
        case 4:
          accessRoutes = _context.v;
          // dynamically add accessible routes
          router.addRoutes(accessRoutes);

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next(_objectSpread(_objectSpread({}, to), {}, {
            replace: true
          }));
          _context.n = 7;
          break;
        case 5:
          _context.p = 5;
          _t = _context.v;
          _context.n = 6;
          return store.dispatch('user/resetToken');
        case 6:
          Message.error(_t || 'Has Error');
          next("/login?redirect=".concat(to.path));
          NProgress.done();
        case 7:
          _context.n = 9;
          break;
        case 8:
          /* has no token*/
          if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            next("/login?redirect=".concat(to.path));
            // next()
            NProgress.done();
          }
        case 9:
          return _context.a(2);
      }
    }, _callee, null, [[2, 5]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});